import autoPlayPadrao from '@/assets/autoPlayTemplates/autoPlay.svg';
import autoPlayAnimation from '@/assets/autoPlayTemplates/autoPlayAnimation.svg';
import autoPlayBlur from '@/assets/autoPlayTemplates/autoPlayBlur.svg';
import autoPlayFullScreen from '@/assets/autoPlayTemplates/autoPlayFullScreen.svg';
import autoPlayLarge from '@/assets/autoPlayTemplates/autoPlayLarge.svg';
import autoPlayMini from '@/assets/autoPlayTemplates/autoPlayMini.svg';
import autoPlayTransparent from '@/assets/autoPlayTemplates/autoPlayTransparent.svg';

export interface AutoplayTemplate {
  id: string;
  name: string;
  image: string;
  description: string;
  colors: {
    background: string;
    text: string;
    icon: string;
    border?: string;
  };
  style?: {
    size?: 'small' | 'medium' | 'large' | 'fullscreen';
    hasWhiteBorder?: boolean;
    hasPulse?: boolean;
    blur?: boolean;
    transparent?: boolean;
  };
}

// Template options for autoplay overlay (7 templates) - Mapeados do projeto original
export const templates: AutoplayTemplate[] = [
  {
    id: 'autoPlay',
    name: 'Padrão',
    image: autoPlayPadrao,
    description: 'Modelo padrão com boa visibilidade',
    colors: {
      background: 'rgba(0, 170, 255, 0.46)', // #00AAFF75
      text: '#FFFFFF',
      icon: '#FFFFFF',
      border: '#FFFFFF'
    },
    style: {
      size: 'medium',
      hasWhiteBorder: false,
      hasPulse: false
    }
  },
  {
    id: 'small',
    name: 'Pequeno',
    image: autoPlayMini,
    description: 'Versão compacta e discreta',
    colors: {
      background: 'rgba(0, 170, 255, 0.46)',
      text: '#FFFFFF',
      icon: '#FFFFFF',
      border: 'rgba(255, 255, 255, 0)'
    },
    style: {
      size: 'small',
      hasWhiteBorder: false,
      hasPulse: false
    }
  },
  {
    id: 'large',
    name: 'Grande',
    image: autoPlayLarge,
    description: 'Destaque máximo para o autoplay',
    colors: {
      background: 'rgba(0, 170, 255, 0.46)',
      text: '#FFFFFF',
      icon: '#FFFFFF',
      border: 'rgba(255, 255, 255, 0)'
    },
    style: {
      size: 'large',
      hasWhiteBorder: false,
      hasPulse: false
    }
  },
  {
    id: 'fullScreen',
    name: 'Tela Cheia',
    image: autoPlayFullScreen,
    description: 'Cobre toda a tela do vídeo',
    colors: {
      background: 'rgba(0, 170, 255, 0.46)',
      text: '#FFFFFF',
      icon: '#FFFFFF',
      border: 'rgba(255, 255, 255, 0)'
    },
    style: {
      size: 'fullscreen',
      hasWhiteBorder: false,
      hasPulse: false
    }
  },
  {
    id: 'transparent',
    name: 'Transparente',
    image: autoPlayTransparent,
    description: 'Fundo transparente e clean',
    colors: {
      background: 'rgba(0, 170, 255, 0.15)', // Mais transparente
      text: '#FFFFFF',
      icon: '#FFFFFF',
      border: 'rgba(255, 255, 255, 0.3)'
    },
    style: {
      size: 'medium',
      hasWhiteBorder: true,
      hasPulse: false,
      transparent: true
    }
  },
  {
    id: 'blur',
    name: 'Censurado',
    image: autoPlayBlur,
    description: 'Efeito de desfoque no fundo',
    colors: {
      background: 'rgba(0, 0, 0, 0.25)',
      text: '#FFFFFF',
      icon: '#FFFFFF',
      border: 'rgba(255, 255, 255, 0.2)'
    },
    style: {
      size: 'medium',
      hasWhiteBorder: false,
      hasPulse: false,
      blur: true
    }
  },
  {
    id: 'animation',
    name: 'Animado',
    image: autoPlayAnimation,
    description: 'Com animação de pulso chamativa',
    colors: {
      background: 'rgba(0, 170, 255, 0.46)',
      text: '#FFFFFF',
      icon: '#FFFFFF',
      border: 'rgba(255, 255, 255, 0.3)'
    },
    style: {
      size: 'medium',
      hasWhiteBorder: true,
      hasPulse: true
    }
  }
];
